/* tslint:disable */
/* eslint-disable */
/**
 * VerCasa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface City
 */
export interface City {
    /**
     * 
     * @type {string}
     * @memberof City
     */
    name: string;
}

/**
 * Check if a given object implements the City interface.
 */
export function instanceOfCity(value: object): value is City {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CityFromJSON(json: any): City {
    return CityFromJSONTyped(json, false);
}

export function CityFromJSONTyped(json: any, ignoreDiscriminator: boolean): City {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function CityToJSON(value?: City | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

